import { atom } from "jotai";
export const dashboardViewModeAtom = atom("grid");
export const searchTextAtom = atom("");
export const statusFilterAtom = atom("all");
